import { render } from "./App.vue?vue&type=template&id=d8b108ac"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=d8b108ac&lang=css"
script.render = render

export default script